var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-frames"},[_c('div',{staticClass:"loading-frames__spinner"}),_c('div',{staticClass:"loading-frames__content"},[_vm._v(_vm._s(_vm.$t('Loading animation'))+" - "+_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }